import styled from 'styled-components'

export const ContentMini = styled.div`
  margin-top: 0px;
  text-align: center;
`;

export const InputPwd = styled.input`
  padding: 10px;
  color: black;
  width: 400px;
  margin: auto;
  font-size: 20px;
`;

export const ContainerPrimary = styled.div`
  background-color: white !important;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  /* height: 100vh; */
`;

export const Container = styled.div`
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  /* height: 100vh; */
`;

export const Content = styled.div`
  text-align: center;
  margin-top: 100px;
`;

export const Logo = styled.img`
  width: auto;
  height: 100px;
  margin-bottom: 20px;
  margin-bottom: 50px;
  &:first-child {
    margin-right: 50px;
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
`;

export const Input = styled.input`
  padding: 10px;
  color: black;
  width: 400px;
  margin: auto;
  font-size: 20px;
`;

export const Label = styled.label`
  color: black;
  margin-bottom: 5px;
  width: 330px;
  font-size: 20px;
  font-weight: bold;
  text-align: left;
`;

export const Button = styled.button`
  background-color: white;
  color: black;
  padding: 10px 20px;
  border: none;
  cursor: pointer;
  width: 300px;
  margin: auto;
  margin-top: 120px;
  font-size: 20px;
  font-weight: bold;
  border-radius: 5px;
`;
